import React, {PropTypes} from 'react';


class Logo extends React.PureComponent {
  static propTypes = {
    city: PropTypes.string,
    country: PropTypes.string,
    name: PropTypes.string
  };

  render() {
    return (
      <div className="logo-wrapper">
        <h2>{this.props.name}</h2>
        <h5>{this.props.city}, {this.props.country}</h5>
      </div>
    );
  }
}

export default Logo;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/Logo.js
 **/